module.exports = __webpack_public_path__ + "img/005-understanding.0cfc3489.svg";